import styled from 'styled-components';

import { Tag } from '#@/components/Tag';
import { COLOR, GRADIENT } from '#@/shared/utils/styles';

export const StyledTag = styled(Tag)`
  background: ${GRADIENT.subcontractorPremium};
  color: ${COLOR.white};
  height: max-content;
`;
